import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CargoMarking from './IntegrationBlock/components/CargoMarking';
import DeliveryInterval from './IntegrationBlock/components/DeliveryInterval';
import TransportInfo from './IntegrationBlock/components/TransportInfo';
import DeliveryItem from './IntegrationBlock/components/DeliveryItem/DeliveryItem';
import Toogle from '../../common/Toogle';
import { useDispatch } from 'react-redux';
import { fetchGetOzonInfo, fetchPostOzonFbo } from '../../../actions/orders';
import styled from '@emotion/styled';
import { toast } from 'react-toastify';
import SupplyData from './IntegrationBlock/components/SupplyData';

const Wrapper = styled('div')`
  background-color: #fff;

  .toggle-wrapper {
    display: flex;
    align-items: center;
    column-gap: 8px;
    padding: 10px 1.5rem;
  }

  .title {
    margin: 0;
    font-size: 16px;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dee2e6;
    padding: 28px 1.5rem 29px;
  }
`;

const OzonBlocks = (props) => {
  const { permissionList, orderId, isFboAuto, setIsCopy, isCopy, actualizeOrder } = props;
  const { ozonInfo } = useSelector((state) => state.orders);
  const cancelPermission = permissionList.find((item) => item.type === 'CANCEL');

  const [showOzonFbo, setShowOzonFbo] = useState(isFboAuto);

  const dispatch = useDispatch();

  const handleFboCheck = async (bool) => {
    setIsCopy(false);
    const res = await dispatch(
      fetchPostOzonFbo({
        id: orderId,
        value: bool,
      }),
    );

    if (bool && res.success) {
      await dispatch(fetchGetOzonInfo(orderId));
    }

    setShowOzonFbo(bool);
    actualizeOrder(orderId);
    //? Если нужно будет обновить весь заказ, надо пробросить и вызвать  из index.jsx
  };

  const handleUpdateOzonData = async () => {
    await dispatch(fetchGetOzonInfo(orderId)).then(() => {
      toast.info('Данные были обновлены');
    });
  };

  return (
    <Wrapper className="card">
      <div className="header">
        <h4 className="title">Интеграция OZON FBO</h4>
        {showOzonFbo && !isCopy && (
          <div className="change-link" onClick={() => handleUpdateOzonData()}>
            Обновить данные
          </div>
        )}
      </div>
      <div className="toggle-wrapper">
        <span>Стандарт</span>
        <Toogle
          id="isFboAuto"
          label="Авто"
          onChange={(e) => handleFboCheck(e.target.checked)}
          checked={showOzonFbo && !isCopy}
        />
      </div>
      {showOzonFbo && !isCopy && (
        <div className="content">
          <DeliveryItem
            data={ozonInfo}
            modalType="EditDeliveryItemOzon"
            isSaveable={cancelPermission.value}
            isChangeable={true}
          />
          <DeliveryInterval
            data={ozonInfo}
            modalType="EditTimeIntervalOzon"
            isSaveable={cancelPermission.value}
            isChangeable={true}
          />
          <SupplyData data={ozonInfo} modalType="" isSaveable={false} isChangeable={false} />
          <TransportInfo
            data={ozonInfo}
            modalType="EditTransportInfo"
            isSaveable={cancelPermission.value}
            isChangeable={true}
          />
          <CargoMarking
            data={ozonInfo}
            modalType="ShowCargoMarking"
            isSaveable={cancelPermission.value}
            isChangeable={false}
          />
        </div>
      )}
    </Wrapper>
  );
};

export default OzonBlocks;
